<template>
  <a v-if="showIpAccess" v-bind:href="ipAccessHref">
    <i class="fa-light me-1" v-bind:class="ipAccessStyleClass"/>{{ ipAccessText }}
  </a>
</template>

<script>
import Vue from "vue";

export default {
  name: "ip-access-toggle",
  data: function () {
    return {
      visitor: window.visitor,
      bundle: {
        id_11352: "IP access active",
        id_11353: "IP access inactive",
      },
    }
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
  },
  computed: {
    showIpAccess: function () {
      return this.visitor.ipAccess && this.visitor.ipAccess.disableAddon && this.window.access.module.subscriptions;
    },
    ipAccessHref: function () {
      return "?disableIpAccess=" + !this.visitor.ipAccess.disable;
    },
    ipAccessStyleClass: function () {
      return this.visitor.ipAccess.disable ? "fa-lock" : "fa-lock-open";
    },
    ipAccessText: function () {
      return this.visitor.ipAccess.disable ? this.bundle.id_11353 : this.bundle.id_11352;
    }
  }
}
</script>
